import { getIntrospectionQuery } from "graphql";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
async function fetchAemIntrospection(options) {
  const { aemEndpoint, logger } = options;
  const { origin, authorizationHeaders } = aemEndpoint;
  const schemaUrl = new URL(
    `/content/_cq_graphql/global/endpoint.json`,
    origin
  );
  logger == null ? void 0 : logger(`Fetching AEM introspection from AEM endpoint from "${schemaUrl}".`);
  const response = await fetch(schemaUrl.href, {
    method: `POST`,
    headers: { ...authorizationHeaders, "Content-Type": `application/json` },
    body: JSON.stringify({ query: getIntrospectionQuery({ descriptions: false }) })
  });
  if (!response.ok) {
    throw Error(
      `Could not fetch AEM introspection (${response.status} ${response.statusText})`
    );
  }
  const introsprectionResponse = await response.json();
  return introsprectionResponse;
}
export {
  commonjsGlobal as c,
  fetchAemIntrospection as f,
  require$$0 as r
};
//# sourceMappingURL=fetch-aem-introspection-jxPXzmGT.mjs.map
